import axios from "axios";
import router from "@/router";
import { useCustomerStore } from "@/stores/customerStore";

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const customerStore = useCustomerStore();
      customerStore.customer = null;
      customerStore.shops = [];
      customerStore.isAuthenticated = false;
      localStorage.removeItem("auth_token");

      if (router.currentRoute.value.name !== "Login") {
        const email = customerStore.customer?.email;
        router.push({ name: "Login", ...(email ? { query: { email } } : {}) });
      }
    }
    return Promise.reject(error);
  },
);

export default axios;